import request from 'src/network';
import { fileToBase64 } from './AssetService';

export function renameFolder(domainId: string, key_folder: string, newName: string) {
    return request.POST(`/api/v1/${domainId}/flow/${key_folder}/folder/rename`, { name: newName } as any);
}

export async function findFolderByAgentName(baseUrl: string, domainId: number, key_retriever: string) {
    if (!key_retriever) return { success: false, items: [], folder: undefined };
    const fetchOptions = {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json, text/plain, */*'
        },
    };

    const res = await fetch(`${baseUrl}/api/v1/${domainId}/flow/${key_retriever}/folder`, fetchOptions);
    console.log(res);
    return request.GET(`/api/v1/${domainId}/flow/${key_retriever}/folder`);
}

export function createFolder(domainId: string, key_retriever: string) {
    return request.POST(`/api/v1/${domainId}/flow/${key_retriever}/folder/create`, {});
}

export function deleteFolder(domainId: number, key_folder: string) {
    return request.DELETE(`/api/v1/${domainId}/flow/${key_folder}/folder/delete`, {});
}

export function deleteFile(domainId: number, key_retriever: string, fileKey: string) {
    return request.DELETE(`/api/v1/${domainId}/flow/${key_retriever}/folder?fileKey=${fileKey}`);
}

export async function uploadFile(domainId: number, key_retriever: string, body: File[], folderKey: string) {
    await Promise.all(
        body.map(async (file) => {
            const toBase64 = await fileToBase64(file);
            return request.POST(`/api/v1/${domainId}/flow/${key_retriever}/folder?folderKey=${folderKey}`, {
                file_name: file.name,
                file_content: toBase64,
            });
        })
    );

    return {
        success: true,
        message: 'Files uploaded successfully',
    };
}

export interface SyncVectorStorePayload {
    provider: string;
    index_name?: string;
    folder: string;
    vector_store_config: {
        k: number;
        namespace?: string;
        fetch_k?: number;
        chunk_size: number;
        search_type: string;
        chunk_overlap: number;
        lambda_mult?: number;
        score_threshold?: number;
    };
}

export function syncVectorStore(payload: SyncVectorStorePayload) {
    return request.POST(`/api/v3/agent/synchronize`, payload);
}

export interface VectorStoreSyncHistory {
    id: number;
    conversation_id: string | null;
    error: string | null;
    message: string;
    timestamp: string;
    created_at: string;
    updated_at: string;
    audit_type: string;
    domain: string;
}

export function getVectorStoreSyncHistory(domainId: number, namespace: string) {
    return request.GET<VectorStoreSyncHistory[]>(`/api/v1/${domainId}/vector_store/${namespace}`);
}

export async function deleteFilesAndFolder(
    keys: string[],
    key_retriever: string,
    folder_key: string,
    domain_id: number
) {
    try {
        for (const key of keys) {
            await deleteFile(domain_id, key_retriever, key);
        }

        await deleteFolder(domain_id, folder_key);
    } catch (err) {
        console.error('Error deleting files:', err);
    }
}
